import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";

const ServiceCard = ({ icon, title, details, detailData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleDetailsClick = () => {
    navigate("/service-details", {
      state: detailData,
    });
  };

  return (
    <div className="col-md-3 col-sm-4 mb-4">
      <div className="card h-100 shadow-sm">
      <div className="text-center mt-3">
  <img
    className="blue-color-code"
    src={icon}
    alt="home"
    style={{
      height: "7em",
      width: "7em",
      objectFit: "contain",
    }}
  />
</div>
        <div className="card-body d-flex flex-column p-4">
          <h4
            className="card-title text-center font-weight-bold"
            style={{ cursor: "pointer" }}
            onClick={handleDetailsClick}
          >
            {title}
          </h4>

          {details && (
            <>
              <ul className="text-start list-unstyled mt-3">
                {details.map((point, index) => (
                  <li key={index}> {point}</li>
                ))}
              </ul>
              <div className="mt-auto text-center">
                <button
                  className="btn mt-3 blue-color-code text-white"
                  onClick={handleDetailsClick}
                >
                  {t("more_details_button")}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
